<pcg-table
    [canGlobalSearch]="false"
    [pcgSort]="[['goLiveDateString', 'desc']]"
    dataSource="api/ReleaseNotes/GetWebReleaseNotesList"
    [columnDefs]="columns"
>
    <!-- Version Number -->
    <ng-container matColumnDef="versionNumber">
        <th width="15%" mat-header-cell [pcg-sort-header]="'versionNumber'" *matHeaderCellDef>
            {{ columns.get('versionNumber').displayName }}
        </th>
        <td mat-cell *matCellDef="let row">
            {{ row.versionNumber }}
        </td>
    </ng-container>
    <!-- Go Live Date -->
    <ng-container matColumnDef="goLiveDateString">
        <th width="15%" mat-header-cell [pcg-sort-header]="'goLiveDateString'" *matHeaderCellDef>
            {{ columns.get('goLiveDateString').displayName }}
        </th>
        <td mat-cell *matCellDef="let row">
            {{ row.goLiveDateString }}
        </td>
    </ng-container>
    <!-- Description of Change -->
    <ng-container matColumnDef="releaseNotes">
        <th width="70%" mat-header-cell [pcg-sort-header]="'releaseNotes'" *matHeaderCellDef>
            {{ columns.get('releaseNotes').displayName }}
        </th>
        <td mat-cell *matCellDef="let row" [innerHTML]="row.releaseNotes"></td>
    </ng-container>
</pcg-table>
